module.exports = __webpack_public_path__ + "img/header-1.10502e9.jpg";